import type { Components, Theme } from "@mui/material";

export const accordionTheme: Components<Theme>["MuiAccordion"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&:before": {
        display: "none",
      },
      borderRadius: "8px!important",
      border: `1px solid ${theme.palette.custom.border}`,
    }),
  },
};
